import { useMutation } from "@tanstack/react-query";
import { api } from "../../libs/axios";
import { PagamentoLink } from "../../utils/interfaces";

export function useMutationLinkPagamento(id: string) {
  return useMutation({
    mutationFn: async (): Promise<PagamentoLink> => {
      const response = await api.post(`/checkout/link-pagamento/${id}`);
      const payload = response.data?.data?.data ?? response.data?.data ?? response.data;

      return payload as PagamentoLink;
    },
  });
}
